export const page = async () => {
    if (window.location.pathname == '/terminos-condiciones'){
        var contentPanelTerminos = document.getElementById("contentPanelTerminos");
        var itemsAccordion = document.querySelectorAll(".accordionBacana");
        var iconsAccordion = document.querySelectorAll(".accordionBacana > .icon > i");
        var sectionsContent = document.querySelectorAll(".sections--content");
        var firstContentPanel = document.querySelectorAll(".sections--content");
        firstContentPanel.forEach(element => element.classList.toggle("panel-show"));
       
        itemsAccordion.forEach((element) => {
            element.addEventListener("click", function(){
                // iconsAccordion.forEach(element => element.className = 'fas fa-plus');
    
                if (this.nextElementSibling.classList.contains("panel-show")){
                    this.nextElementSibling.classList.toggle("panel-show");
                    this.classList.toggle("sections-selected");
                    contentPanelTerminos.style.backgroundSize = 'cover';
                    this.children[1].children[0].className = "fas fa-plus";
                } else {
                    // sectionsContent.forEach(element => element.classList.remove("panel-show"));
                    itemsAccordion.forEach(element => element.classList.remove("sections-selected"));
                    this.children[1].children[0].className = "fas fa-minus";
                    this.nextElementSibling.classList.toggle("panel-show");
                    this.classList.toggle("sections-selected");
                    // contentPanelTerminos.style.backgroundSize = '180% 150%';
                }
            });
        });
        
        var changeSection = function(idSection: string, textSection: string) {
            let secciones = Array.from(document.getElementsByClassName('sections') as HTMLCollectionOf<HTMLElement>)
            let seccionSelected = document.getElementById(idSection)
            
            // iconsAccordion.forEach(element => element.className = 'fas fa-plus');
            // sectionsContent.forEach(element => element.classList.remove("panel-show"));
            itemSections.forEach(e => e.classList.remove("option-active"));
            // contentPanelTerminos.style.backgroundSize = 'cover';
            itemsAccordion.forEach(element => element.classList.remove("sections-selected"));
            document.querySelector('[item-section="'+idSection+'"]').classList.toggle("option-active");
    
            secciones.forEach(element => element.style.display = 'none');
            seccionSelected.style.display = 'block';
    
            document.querySelector("#title-panel-selected").textContent = textSection;
        };
    
        var itemSections = document.querySelectorAll(".item-section");
        itemSections.forEach((el) => {
            let idSection = el.getAttribute('item-section');
            let textSection = el.textContent;
            el.addEventListener("click", function(){
                changeSection(idSection, textSection);
            });
        })
    }
}